/**
 * BatchGeoCaptcha provides a stupid simple way to add reCaptcha to BatchGeo
 * client side features. It handles the loading of the compoment, setup, keys,
 * and more so you can just worry about what happens after the user hits submit.
 *
 * This will create an invisible captcha and will only pop up the captcha if
 * Google thinks something is 🐟.
 *
 * @example
 * handleCaptcha = function (token) {
 *   // Send this token off to your backend implementation to verify
 *   // You can see an example of this in /api/emailOwner.php
 * }
 *
 * this.batchGeoCaptchaInstance = new BatchGeoCaptcha({
 *   container: this.$form,
 *   callback: handleCaptcha
 * });
 *
 */
(function (window) {
  var API_URL =
    "https://www.google.com/recaptcha/api.js?onload=__BATCHGEO_CAPTCHA_CALLBACK__&render=explicit";
  var SITE_KEY = "6LdOGlAUAAAAACNbU2IaP69da2C7_1GTVTOXX3L3";

  /**
   * This will download the reCaptcha libraries if they haven't already been
   * downloaded. Once downloaded it will call the callback parameter set in
   * the BatchGeoCaptcha options.
   *
   * @param {function} callback A function that is called once Google's
   * reCaptcha is finished loading and initializing or immediately if the
   * script has already been downloaded.
   */
  var loadRecaptcha = function (callback) {
    // If it's already loaded we can fire the callback right away.
    // This is named this way and global so that the same recaptcha script
    // doesn't need to be redownloaded for every instance.
    if (window.__BATCHGEO_CAPTCHA_LOADED__) {
      callback();
    } else {
      window.__BATCHGEO_CAPTCHA_CALLBACK__ = function () {
        window.__BATCHGEO_CAPTCHA_LOADED__ = true;
        callback();
      };
      // Note the missing callback. That's because the callback is called
      // by Google. The callback to call is defined in the API_URL. If you
      // try to just call the callback in the callback for the script
      // download it will fail.
      $.getScript(API_URL);
    }
  };

  /**
   *
   * @param {object} options An options hash
   *
   * @param {*} options.container The container you want to inject the
   * invisible captcha
   *
   * @param {function} options.callback A callback to fire after execute() is
   * called. It will pass a token down that you will need to pass to your
   * backend implementation as the first param.
   *
   * @constructor
   */
  var BatchGeoCaptcha = function (options) {
    var self = this;

    this.options = _.merge(
      {
        container: null,
        callback: function () {},
      },
      options,
    );

    loadRecaptcha(function () {
      // Generate a new, empty div to inject the captcha into. reCaptcha
      // will NOT work if there's anything inside of an element so we need
      // to create a brand new, empty div.
      var $renderElement = $("<div />", { "data-size": "invisible" }).appendTo(
        self.options.container,
      );

      // Here we are rendering the captcha and we save the instance ID to
      // to the component instance. This way other proxy methods to Google
      // will automatically have context.
      self.id = grecaptcha.render($renderElement[0], {
        sitekey: SITE_KEY,
        callback: self.options.callback,
      });
    });
  };

  /**
   * Runs the reCaptcha check on the current user. This will automatically pop
   * open a 🤖 test if it suspects you're one.
   */
  BatchGeoCaptcha.prototype.execute = function () {
    // Must check for undefined and not !this.id because this.id is 0 for
    // the first captcha google finds so this will always fail.
    if (this.id === undefined) {
      return console.error("BatchGeoCaptcha is not loaded yet");
    }

    grecaptcha.execute(this.id);
  };

  window.BatchGeoCaptcha = BatchGeoCaptcha;
})(window);
